export default __webpack_public_path__ + "static/media/sprite-download-check-white@2x.1ac35bb5.png";